<!-- <app-data-table [columns]="cols" [data]="systems" [title]="title"></app-data-table> -->


<ng-container>
  <app-data-table [columns]="cols" [data]="system" [isCardView]="false" (onPresentView)="getSystem()" [url]="'/master/class-master/'"
    [isDeletable]="'/master/class' | hasPermission: 'Delete'"  [showAddButton]="'/master/class' | hasPermission: 'Add'" [showActions]="canEditSetup" [isEditable]="'/master/class' | hasPermission: 'Edit'"  [title]="title" (onAdd)="addSystem()" (editEventRow)="updateSystem($event)" [isView]="'/master/class' | hasPermission: 'View'" (viewEventRow)="viewSystem($event)"
    (deleteEventRow)="showDeletePopup($event)" (onLazyLoadData)="getSystem($event)" [totalRecords]="totalRecords">
  </app-data-table>
</ng-container>

<app-reusable-dialog
  [(visible)]="showDialog"
  [config]="addDialogConfig"
  [initialData]="{}"
  [viewMode]="false"
  (onSubmit)="onSubmitAdd($event)"
  (onCancel)="onCancelAdd()"
  (onClose)="onCloseAdd()"
></app-reusable-dialog>


<app-reusable-dialog
  [(visible)]="isUpdatedialog"
  [config]="updateDialogConfig"
  [initialData]="selectedClassData"
  [viewMode]="viewMode"
  (onSubmit)="onSubmitUpdate($event)"
  (onCancel)="onCancelUpdate()"
  (onClose)="onCloseUpdate()"
></app-reusable-dialog>

<p-dialog header="Delete Class" [modal]="true" [(visible)]="showDeleteDialog" [style]="{ width: '30rem' }" [maximizable]="true">
  <div class="delete-dialog mt-3">
     <i class="pi pi-trash text-danger custom-delete-icon"></i>
    <span>Are you sure , you want to delete class ?</span>
    <p-button label="Delete" icon="pi pi-trash" severity="danger" [outlined]="true" (click)="deleteSystem()" class="mt-2">
    </p-button>
  </div>
</p-dialog>